export const TIME = 'GAUGE_TIME';
export const DATA = 'GAUGE_DATA';
export const CW = 'GAUGE_CW';
export const CCW = 'GAUGE_CCW';
